import o from "./borders.mjs";
import r from "./breakpoints.mjs";
import m from "./colors.mjs";
import * as i from "./icons.mjs";
import t from "./radius.mjs";
import p from "./shadows.mjs";
import s from "./sizes.mjs";
import { spacing as f } from "./spacing.mjs";
import a from "./transition.mjs";
import * as n from "./typography.mjs";
import e from "./z-index.mjs";
import c from "./blur.mjs";
const x = {
  breakpoints: r,
  zIndices: e,
  radii: t,
  blur: c,
  colors: m,
  ...i,
  ...n,
  sizes: s,
  shadows: p,
  space: f,
  borders: o,
  transition: a
};
export {
  x as default
};
